import React from 'react';
import PropTypes from 'prop-types';
import { dateToString } from '../../../common/utils/date/Date.utils';
import { preparePriceFormat } from '../../../helpers/preparePriceFormat';

function DealerTransactionsTableRow({ item }) {
  const { serial, title, createdOn, amountInPence, organization } = item;

  return (
    <>
      <td>{serial}</td>
      <td>{title}</td>
      <td>{dateToString(createdOn)}</td>
      <td>{preparePriceFormat(amountInPence) || '-'}</td>
      <td>{organization?.tradeName}</td>
    </>
  );
}

DealerTransactionsTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default DealerTransactionsTableRow;
